import { Button } from 'components/ui'
import React, { useEffect, useState } from 'react'
import { Trans } from 'react-i18next'
import { HiArrowRight } from 'react-icons/hi'
import { HiOutlineCheckCircle } from 'react-icons/hi2'
import { dispatch } from 'use-bus'

const ToolHeader = ({
    tool,
    posts = [],
    setPosts = (array) => void 0
}) => {

    return (
        <>
            {!tool?.hideHeader && <div className="relative z-[50] shrink-0 flex w-full overflow-x-hidden bg-secondary-500 dark:bg-gray-800 shrink-0 !border-b !border-tertiary-100 dark:!border-gray-700">
                <div className='flex justify-between items-center w-full h-fit'>
                    <div className='flex flex-col gap-4 w-full max-w-[650px] shrink-0 px-10 pr-6 py-6 lg:py-4'>
                        <h3 className='mega-title !text-2xl lg:!text-3xl flex items-center gap-4 justify-center text-center lg:text-left lg:justify-start text-tertiary-500 dark:text-gray-400'><span className='hidden lg:inline-block !h-[35px] lg:h-auto'>{tool.emoji}</span> <Trans i18nKey={tool.title} /></h3>
                        <p className='text-sm lg:text-base text-center lg:text-left'><Trans i18nKey={tool.long_description} /></p>
                        {/* <Button onClick={} size="md" variant="twoTone" className="mt-4 inline-flex items-center w-fit"><span>Learn More &nbsp;</span><HiArrowRight className='text-primary-600' /></Button> */}
                    </div>
                    <div className='hidden lg:block'>
                        <img src="/img/others/header-analytics.png" className='h-[210px] drop-shadow' />
                    </div>
                </div>
            </div>}
        </>
    )
}

export default ToolHeader
